/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export * from './FormGroup';
export * from './FormInput';
